module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-field",
    staticStyle: {
      "margin-top": "45px"
    }
  }, [_c('div', [_c('mt-file-list', {
    attrs: {
      "file-list": _vm.fileList,
      "label": "这里是传进来的标题"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-162bbacc","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/file-list.vue
// module id = 521
// module chunks = 0